/**
 * Default configuration for QuickBooks synchronization
 */

// Get current date for dynamic calculations
const now = new Date();

// Calculate the last day of the last full month as YYYY-MM-DD string.
function getLastDayOfLastFullMonth() {
  const firstOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(firstOfCurrentMonth - 1);
  const year = lastDay.getFullYear();
  const month = String(lastDay.getMonth() + 1).padStart(2, '0');
  const day = String(lastDay.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Dynamically calculated as the last day of the last full month
// This is the date that determines the end of the GL sync period
export const GL_SYNC_END_DATE = getLastDayOfLastFullMonth();

// TB sync dates - fixed at 2023-12-31
const tbDate = `2023-12-31`;
export const TB_SYNC_DATES = {
  startDate: tbDate,
  endDate: tbDate
};


// GL sync dates - from 2024-01-01 to end of last full month
export const GL_SYNC_DATES = {
  startDate: `2024-01-01`,
  endDate: GL_SYNC_END_DATE
};
